var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('iframe',{staticClass:"custom-iframe",style:({ height: _vm.iframeHeight + 'px', width: '100%' }),attrs:{"src":_vm.link.href}}):_c('div',{staticClass:"no-link"},[_c('p',[_vm._v("Aucun lien sélectionné.")])])}
var staticRenderFns = []

export { render, staticRenderFns }